import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Transport } from '../../../../../models/transport.model';
import { TransportService } from '../../../../../services/transport.service';
import { AbstractTransport } from '../../../../../models/abstract-transport.model';
import { Subject } from 'rxjs';
import { PATHS } from '../../../../../models/bary-paths.model';
import { LIST_MAILTO } from '../../bary-mailto/bary-mailto.component';
import { UserMinimal } from '../../../../../models/user-minimal.model';
import { ITransportEstimationResult } from '../../../../../models/transport-estimation-result.model';
import { BaryErrorService } from '../../../../../services/bary-error-service';
import { CurrentDataService } from '../../../../../services/current-data-service';
import { EstimationStatus } from '../../../../../models/estimate-result-bundle.model';
import { TransportOrderView } from '../../../../../models/transport-order-view.model';
import { FaDirectiveEnum } from '../../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-transport-line',
  templateUrl: './transport-line.component.html',
  styleUrls: ['./transport-line.component.scss'],
})
export class TransportLineComponent implements OnInit {
  readonly #transportService = inject(TransportService);
  readonly #baryErrorService = inject(BaryErrorService);
  readonly #currentDataService = inject(CurrentDataService);

  @Input() transportEstimation?: ITransportEstimationResult;
  @Input() transportOrder?: TransportOrderView;
  @Input() isPreview = false;
  @Input() stickerSubject?: Subject<string>;

  @Input() documentEmailTransporter?: string | undefined;
  @Input() companyName?: string | undefined;
  @Input() isBasket: boolean = false;
  @Input() isReturnPaymentDeffered: boolean = false;

  @Output() editEvent = new EventEmitter<Transport>();
  @Output() removeEvent = new EventEmitter<Transport>();

  public showDetail = false;
  public transport?: AbstractTransport;
  public transportLoaded = false;
  public isTransportOrder = false;
  public errorMessages: string[] = [];
  public stickerLoading = true;
  public PATHS = PATHS;
  public userMinimal: UserMinimal = new UserMinimal();

  public LIST_MAILTO = LIST_MAILTO;
  public EstimationStatus = EstimationStatus;

  protected readonly FAR = FaDirectiveEnum.FAR;

  public ngOnInit(): void {
    this.getUserData();

    if (this.transportEstimation?.id) {
      this.#transportService.find(this.transportEstimation.id).subscribe(transport => {
        this.transport = transport;
        this.transportLoaded = true;
      });
    } else if (this.transportOrder?.id) {
      this.transport = this.transportOrder as AbstractTransport;
      this.isTransportOrder = true;
      this.transportLoaded = true;
    }
    if (this.transportEstimation?.errorMessages) {
      this.errorMessages = this.#baryErrorService.baryErrorsToString(this.transportEstimation.errorMessages);
    }
    if (this.transportOrder && this.stickerSubject) {
      this.stickerLoading = true;
      this.stickerSubject.subscribe(() => {
        this.stickerLoading = false;
        this.stickerSubject!.complete();
      });
    }
  }

  public toggleDetails(): void {
    this.showDetail = !this.showDetail;
  }

  public handleEdit(): void {
    this.editEvent.emit(this.transport as Transport);
  }

  public handleRemove(): void {
    this.removeEvent.emit(this.transport as Transport);
  }

  public isNotAQuotation(): boolean {
    return !this.transport?.quotationBasePrice ?? true;
  }

  public getTransportTypeIcon(): string {
    return this.transport?.getOptionsTypeSelector().icon ?? 'baryicon-pallet';
  }

  public getUserData(): void {
    this.#currentDataService.getUser().subscribe(value => {
      this.userMinimal.firstName = value?.firstName;
      this.userMinimal.lastName = value?.lastName;
      this.userMinimal.email = value?.email;
      this.userMinimal.phone = value?.phone;
      this.userMinimal.companyName = value?.companyName;
    });
  }
}
